import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/**
 * QR codes are rendered on demand — client-side here, or `GET /api/qr/:text.svg` for
 * anything that needs a URL. Nothing is stored on the document any more.
 */
export function QrPreview({ qrText, size = 96 }: { qrText: string; size?: number }) {
  const [dataUrl, setDataUrl] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    void QRCode.toDataURL(qrText, { margin: 1, width: size * 2 }).then((url) => {
      if (!cancelled) setDataUrl(url);
    });
    return () => {
      cancelled = true;
    };
  }, [qrText, size]);

  return (
    <img
      src={dataUrl}
      alt={`QR code for ${qrText}`}
      width={size}
      height={size}
      style={{ width: size, height: size }}
      className="shrink-0 rounded border border-ink-200 bg-white"
    />
  );
}
